<script lang="ts" setup>
import type { ConsultationSourceEnumType } from '@forgd/contract/types'
import { ConsultationSourceEnum } from '@forgd/contract/types'
import { Button } from '@forgd/ui-kit/button'

withDefaults(defineProps<{
  cta?: string
  ctaBtnText?: string
  source?: ConsultationSourceEnumType
}>(), {
  source: ConsultationSourceEnum.PublicFooterCta,
})

const { destination } = useConsultationDestination()
const { captureConsultationClick } = useConsultationTracking()
</script>

<template>
  <div class="mx-auto w-full min-w-0 max-w-300 overflow-x-hidden px-4 font-display md:px-5">
    <div class="border-t border-gray-300 py-10">
      <div class="flex w-full min-w-0 max-w-full flex-col gap-5 md:grid md:grid-cols-12 md:items-center">
        <div class="size-55 shrink-0 overflow-hidden md:hidden">
          <client-only>
            <Vue3Lottie
              class="size-full"
              animation-link="https://lottie.host/3e36f507-c59e-4e44-a3fc-10e040ddcb41/kWftBITXT1.json"
            />
          </client-only>
        </div>
        <div class="flex min-w-0 flex-col gap-8.5 md:col-span-7">
          <div class="flex min-w-0 flex-col gap-4">
            <p class="text-base font-semibold text-accent">
              Need support?
            </p>
            <p class="wrap-break-word text-2xl font-normal leading-[1.3] text-primal md:text-4xl md:leading-tight">
              {{ cta || 'Contact us for a 1:1 consultation regarding all things related to your project.' }}
            </p>
          </div>
          <Button as-child size="md" class="self-start">
            <NuxtLink
              :to="destination.to"
              :external="destination.external"
              :target="destination.target"
              :rel="destination.external ? 'noopener noreferrer' : undefined"
              @click="captureConsultationClick(source, destination.to)"
            >
              {{ ctaBtnText || 'Schedule a 1:1 Consultation' }}
            </NuxtLink>
          </Button>
        </div>
        <div class="hidden size-52 shrink-0 overflow-hidden md:col-span-5 md:block md:justify-self-end">
          <client-only>
            <Vue3Lottie
              class="size-full"
              animation-link="https://lottie.host/3e36f507-c59e-4e44-a3fc-10e040ddcb41/kWftBITXT1.json"
            />
          </client-only>
        </div>
      </div>
    </div>
  </div>
</template>
